/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useContext,
} from "react";

import {
  Accordion,
  Button,
  Container,
  Dimmer,
  Divider,
  Dropdown,
  Form,
  Grid,
  Header,
  Icon,
  Input,
  Label,
  Loader,
  Modal,
  Segment,
  Step,
  Table,
  TextArea,
  Message
} from "semantic-ui-react";

import moment from "moment";
import Swal from "sweetalert2";
import { PDFViewer, pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";

import Alertas from "./Alertas";
import BuscadorInput from "./BuscadorInput";
import SimplePDF from "./SimplePDF";

import { auth, db } from "../firebase/firebaseConfig";

import {
  getDocs,
  collection,
  where,
  query,
  doc,
  writeBatch,
  runTransaction,
} from "firebase/firestore";

import AgregarClientesDb from "../firebase/AgregarClientesDb";
import IngresoStCabDB from "../firebase/IngresoStCabDB";
import UpdateIngresoStCabDB from "../firebase/UpdateIngresoStCabDB";
import CodigoEntregaDB from "../firebase/CodigoEntregaDB";

import validarRut from "../funciones/validarRut";
import correlativos from "../funciones/correlativosMultiEmpresa";

import { Regiones } from "./comunas";
import { Servicio } from "./TipDoc";

const IngresoEquiposST = () => {
  const { users } = useContext(
    require("../context/UserContext").UserContext
  );

  const user = auth.currentUser;

  // ============================================================
  // FECHAS
  // ============================================================

  const fechaAdd = useMemo(() => new Date(), []);
  const fechaMod = useMemo(() => new Date(), []);

  // ============================================================
  // ALERTAS
  // ============================================================

  const [alerta, cambiarAlerta] = useState({});
  const [estadoAlerta, cambiarEstadoAlerta] = useState(false);

  // ============================================================
  // DATA
  // ============================================================

  const [cabecera, setCabecera] = useState([]);
  const [ingresado, setIngresado] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [existeCliSerie, setExisteCliSerie] = useState([]);

  const [familia, setFamilia] = useState([]);
  const [tipo, setTipo] = useState([]);
  const [marca, setMarca] = useState([]);
  const [modelo, setModelo] = useState([]);

  const [protocolo, setProtocolo] = useState([]);
  const [testG, setTestG] = useState([]);

  // ============================================================
  // PDF
  // ============================================================

  const [openPdf, setOpenPdf] = useState(false);
  const [datospdf, setDatosPdf] = useState([]);
  const [test, setTest] = useState([]);
  const [testGpdf, setTestGpdf] = useState([]);
  const [usuarioIngreso, setUsuarioIngreso] = useState([]);
  const [userAdd, setUsersAdd] = useState([]);

  // ============================================================
  // FORM CLIENTE
  // ============================================================

  const [folio, setFolio] = useState("");
  const [rut, setRut] = useState("");
  const [entidad, setEntidad] = useState("");
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [direccion, setDireccion] = useState("");
  const [correo, setCorreo] = useState("");
  const [date, setDate] = useState(new Date());
  const [nacim, setNacim] = useState("");

  const [region, setRegion] = useState("Arica y Parinacota");
  const [comuna, setComuna] = useState("");

  const [checked, setChecked] = useState(false);
  const [nomRsf, setNomRsf] = useState("");
  const [dirRsf, setDirRsf] = useState("");
  const [telRsf, setTelRsf] = useState("");

  // ============================================================
  // FORM EQUIPO
  // ============================================================

  const [nomFamilia, setNomFamilia] = useState("");
  const [nomTipo, setNomTipo] = useState("");
  const [nomMarca, setNomMarca] = useState("");
  const [nomModelo, setNomModelo] = useState("");
  const [serie, setSerie] = useState("");
  const [servicio, setServicio] = useState("");
  const [horaMaquina, setHoraMaquina] = useState("");
  const [obs, setObs] = useState("");

  // ============================================================
  // UI / FLOW
  // ============================================================

  const [flag, setFlag] = useState(false);

  const [mostrarInfoEq, setMostrarInfoEq] = useState(false);
  const [mostrarTest, setMostrarTest] = useState(false);

  const [activeCli, setActiveCli] = useState(true);
  const [activeEq, setActiveEq] = useState(false);
  const [activeTest, setActiveTest] = useState(false);

  const [step, setStep] = useState(1);

  // ============================================================
  // BOTONES
  // ============================================================

  const [btnGuardarCab, setBtnGuardarCab] = useState(true);
  const [btnValidarDet, setBtnValidarDet] = useState(true);
  const [btnValidarTest, setBtnValidarTest] = useState(true);

  // ============================================================
  // LOCKS + SPINNERS
  // ============================================================

  const [clienteLocked, setClienteLocked] = useState(false);
  const [equipoLocked, setEquipoLocked] = useState(false);

  const [savingCab, setSavingCab] = useState(false);
  const [savingDet, setSavingDet] = useState(false);
  const [savingCli, setSavingCli] = useState(false);
  const [savingTest, setSavingTest] = useState(false);

  // ============================================================
  // MODALES
  // ============================================================

  const [openModalCli, setOpenModalCli] = useState(false);
  const [confirmCliModal, setConfirmCliModal] = useState(false);
  const [confirmTestModal, setConfirmTestModal] = useState(false);
  const [confirmAnularModal, setConfirmAnularModal] = useState(false);
  const [seriePendienteModal, setSeriePendienteModal] = useState(false);

  const [itemAnular, setItemAnular] = useState("");
  const [existeSerie2, setExisteSerie2] = useState([]);

  // ============================================================
  // VALIDACIÓN TEST
  // ============================================================

  const checktest = useRef([]);
  const checktestg = useRef([]);

  /*
   * IMPORTANTE:
   *
   * savingTest protege visualmente el botón.
   *
   * Este ref protege SINCRÓNICAMENTE la función guardarTest.
   * React puede tardar un render en aplicar:
   *
   *   setSavingTest(true)
   *
   * por lo que dos clicks extremadamente rápidos podrían alcanzar
   * a entrar en la función.
   *
   * Con este ref, la segunda ejecución se corta inmediatamente.
   */
  const confirmandoTestRef = useRef(false);

  // ============================================================
  // HELPERS
  // ============================================================

  const comunasxRegion = useMemo(() => {
    const found = Regiones.find((o) => o.region === region);
    return found?.comunas || [];
  }, [region]);

  const formatearFecha = (fecha) => {
    if (!fecha?.toDate) return "";
    return moment(fecha.toDate()).format("DD/MM/YYYY HH:mm");
  };





  // ============================================================
  // RESET COMPLETO
  // ============================================================

  const resetAll = () => {
    setFolio("");
    setRut("");
    setEntidad("");
    setNombre("");
    setTelefono("");
    setDireccion("");
    setCorreo("");
    setNacim("");
    setDate(new Date());

    setNomFamilia("");
    setNomTipo("");
    setNomMarca("");
    setNomModelo("");
    setSerie("");
    setServicio("");
    setHoraMaquina("");
    setObs("");

    /*
     * CORRECCIÓN:
     *
     * Antes protocolo/testG podían mantener respuestas de la orden
     * anterior.
     */
    setProtocolo([]);

    setTestG((prev) =>
      (prev || []).map((it) => ({
        ...it,
        valorsi: false,
        valorno: false,
        revision: false,
      }))
    );

    setClienteLocked(false);
    setEquipoLocked(false);

    setMostrarInfoEq(false);
    setMostrarTest(false);

    setActiveCli(true);
    setActiveEq(false);
    setActiveTest(false);

    setStep(1);

    setBtnGuardarCab(true);
    setBtnValidarDet(true);
    setBtnValidarTest(true);

    setSavingCab(false);
    setSavingDet(false);
    setSavingCli(false);
    setSavingTest(false);

    setFlag((v) => !v);
  };

  // ============================================================
  // LOADERS
  // ============================================================

  const consultarCab = async () => {
    if (!users?.emp_id) return;

    const cab = query(
      collection(db, "ingresostcab"),
      where("emp_id", "==", users.emp_id),
      where("confirmado", "==", false)
    );

    const snap = await getDocs(cab);

    setCabecera(
      snap.docs.map((d) => ({
        ...d.data(),
        id: d.id,
      }))
    );
  };

  const consultarIn = async () => {
    if (!users?.emp_id) return;

    const ing = query(
      collection(db, "ingresostcab"),
      where("emp_id", "==", users.emp_id),
      where("estado", "==", "INGRESADO")
    );

    const snap = await getDocs(ing);

    const arr = snap.docs.map((d) => ({
      ...d.data(),
      id: d.id,
    }));

    arr.sort(
      (a, b) =>
        (a.folio ?? 0) -
        (b.folio ?? 0)
    );

    setIngresado(arr);
  };

  const consultarClientes = async () => {
    if (!users?.emp_id) return;

    const q = query(
      collection(db, "clientes"),
      where("emp_id", "==", users.emp_id)
    );

    const snap = await getDocs(q);

    setClientes(
      snap.docs.map((d) => ({
        ...d.data(),
        id: d.id,
      }))
    );
  };

  const consultarUsuario = async () => {
    if (!users?.emp_id) return;

    const q = query(
      collection(db, "usuarios"),
      where("emp_id", "==", users.emp_id)
    );

    const snap = await getDocs(q);

    setUsuarioIngreso(
      snap.docs.map((d) => ({
        ...d.data(),
        id: d.id,
      }))
    );
  };

  const getFamilia = async () => {
    if (!users?.emp_id) return;

    const q = query(
      collection(db, "familias"),
      where("emp_id", "==", users.emp_id),
      where("activo", "==", true)
    );

    const snap = await getDocs(q);

    const arr = snap.docs.map((d) => ({
      ...d.data(),
      id: d.id,
    }));

    arr.sort((a, b) =>
      String(a.familia || "").localeCompare(
        String(b.familia || "")
      )
    );

    setFamilia(arr);
  };

  const getTipo = async () => {
    if (!users?.emp_id) return;

    if (!nomFamilia) {
      setTipo([]);
      return;
    }

    const q = query(
      collection(db, "tipos"),
      where("emp_id", "==", users.emp_id),
      where("familia", "==", nomFamilia),
      where("activo", "==", true)
    );

    const snap = await getDocs(q);

    const arr = snap.docs.map((d) => ({
      ...d.data(),
      id: d.id,
    }));

    arr.sort((a, b) =>
      String(a.tipo || "").localeCompare(
        String(b.tipo || "")
      )
    );

    setTipo(arr);
  };

  const getMarca = async () => {
    if (!users?.emp_id) return;

    const q = query(
      collection(db, "marcas"),
      where("emp_id", "==", users.emp_id)
    );

    const snap = await getDocs(q);

    const arr = snap.docs.map((d) => ({
      ...d.data(),
      id: d.id,
    }));

    arr.sort((a, b) =>
      String(a.marca || "").localeCompare(
        String(b.marca || "")
      )
    );

    setMarca(arr);
  };

  const getModelo = async () => {
    if (!users?.emp_id) return;

    if (!nomMarca) {
      setModelo([]);
      return;
    }

    const q = query(
      collection(db, "modelos"),
      where("emp_id", "==", users.emp_id),
      where("marca", "==", nomMarca)
    );

    const snap = await getDocs(q);

    const arr = snap.docs.map((d) => ({
      ...d.data(),
      id: d.id,
    }));

    arr.sort((a, b) =>
      String(a.modelo || "").localeCompare(
        String(b.modelo || "")
      )
    );

    setModelo(arr);
  };

  // ============================================================
  // ÓRDENES NO CERRADAS
  // ============================================================

  const getNoCerradas = async () => {
    if (!users?.emp_id) return;

    /*
     * CORRECCIÓN MULTIEMPRESA
     *
     * Antes:
     *
     *   where("estado", "!=", "ENTREGADO")
     *
     * sin emp_id.
     *
     * Eso podía leer órdenes de todas las empresas.
     *
     * Ahora primero restringimos por empresa.
     */
    const qNo = query(
      collection(db, "ingresostcab"),
      where("emp_id", "==", users.emp_id)
    );

    const snap = await getDocs(qNo);

    const arr = snap.docs
      .filter((d) => {
        const estado = d.data().estado;

        return (
          estado !== "ENTREGADO" &&
          estado !== "ANULADO"
        );
      })
      .map((d) => ({
        ...d.data(),
        id: d.id,
      }));

    setExisteCliSerie(arr);
  };

  // ============================================================
  // PROTOCOLO TEST INGRESO
  // ============================================================

  const consultarprot = async (fam, tip) => {
    if (!users?.emp_id || !fam || !tip) {
      setProtocolo([]);
      return;
    }

    /*
     * CORRECCIÓN PRINCIPAL DEL PROBLEMA DE DUPLICADOS
     *
     * ANTES:
     *
     *   emp_id + tipo
     *
     * AHORA:
     *
     *   emp_id + familia + tipo
     *
     * De esta forma un AUTO CPAP, por ejemplo, no puede recibir
     * ítems pertenecientes a otro protocolo que comparta solamente
     * el mismo tipo.
     */
    const q = query(
      collection(db, "protocolostest"),
      where("emp_id", "==", users.emp_id),
      where("familia", "==", fam),
      where("tipo", "==", tip)
    );

    const snap = await getDocs(q);

    const arr = snap.docs.map((d) => ({
      ...d.data(),
      id: d.id,
      valorsi: false,
      valorno: false,
    }));

    arr.sort((a, b) => {
      const fa =
        a.fechamod?.toMillis?.() ?? 0;

      const fb =
        b.fechamod?.toMillis?.() ?? 0;

      return fa - fb;
    });

    setProtocolo(arr);
  };

  // ============================================================
  // TEST GARANTÍA
  // ============================================================

  const testGarantia = async () => {
    if (!users?.emp_id) return;

    const q = query(
      collection(db, "itemsst"),
      where("emp_id", "==", users.emp_id),
      where("categoria", "==", "TEST GARANTIA")
    );

    const snap = await getDocs(q);

    setTestG(
      snap.docs.map((d) => ({
        ...d.data(),
        id: d.id,
        valorsi: false,
        valorno: false,
        revision: false,
      }))
    );
  };

  // ============================================================
  // SELECT CLIENTE
  // ============================================================

  const limpiaFormCte = () => {
    setRut("");
    setEntidad("");
    setTelefono("");
    setDireccion("");
    setCorreo("");
    setBtnGuardarCab(true);
  };

  const handleSelectItem = (item) => {
    if (clienteLocked || savingCab) return;

    const isObject =
      item !== null &&
      typeof item === "object";

    if (isObject) {
      setRut(item.rut || "");
      setEntidad(item.nombre || "");
      setTelefono(item.telefono || "");
      setDireccion(item.direccion || "");
      setCorreo(item.correo || "");

      setNacim(
        item.fnaci?.toDate
          ? item.fnaci.toDate()
          : ""
      );

      setBtnGuardarCab(false);

      return;
    }

    const expresionRegularRut =
      /^[0-9]+[-|‐]{1}[0-9kK]{1}$/;

    const val = String(item || "").trim();

    if (!val) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje: "Favor ingresa un rut",
      });

      return;
    }

    if (!expresionRegularRut.test(val)) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Formato incorrecto de Rut. Sin puntos, solo guión",
      });

      return;
    }

    const temp = val.split("-");

    let digito = temp[1];

    if (
      digito === "k" ||
      digito === "K"
    ) {
      digito = -1;
    }

    const validaR = validarRut(val);

    if (
      validaR !==
      parseInt(digito, 10)
    ) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje: "Rut no válido",
      });

      return;
    }

    setRut(val.toUpperCase());
    setOpenModalCli(true);
  };

  // ============================================================
  // CLIENTE NUEVO
  // ============================================================

  const validarCli = (e) => {
    e.preventDefault();

    cambiarEstadoAlerta(false);
    cambiarAlerta({});

    const expresionRegularEmail =
      /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;

    const expresionRegularRut =
      /^[0-9]+[-|‐]{1}[0-9kK]{1}$/;

    const r = (rut || "").trim();
    const n = (nombre || "").trim();
    const d = (direccion || "").trim();
    const t = String(
      telefono || ""
    ).trim();

    const c = (correo || "").trim();

    if (!r) {
      return Swal.fire(
        "Error",
        "Campo Rut no puede estar vacío",
        "error"
      );
    }

    if (!expresionRegularRut.test(r)) {
      return Swal.fire(
        "Error",
        "Formato incorrecto de rut. Sin puntos, solo guión",
        "error"
      );
    }

    const temp = r.split("-");

    let digito = temp[1];

    if (
      digito === "k" ||
      digito === "K"
    ) {
      digito = -1;
    }

    const validaR = validarRut(r);

    if (
      validaR !==
      parseInt(digito, 10)
    ) {
      return Swal.fire(
        "Error",
        "Rut no válido",
        "error"
      );
    }

    if (!n) {
      return Swal.fire(
        "Error",
        "Campo Nombre no puede estar vacío",
        "error"
      );
    }

    if (!d) {
      return Swal.fire(
        "Error",
        "Campo Dirección no puede estar vacío",
        "error"
      );
    }

    if (!t) {
      return Swal.fire(
        "Error",
        "Campo teléfono no puede estar vacío",
        "error"
      );
    }

    if (
      !expresionRegularEmail.test(c)
    ) {
      return Swal.fire(
        "Error",
        "Favor ingresar un correo válido",
        "error"
      );
    }

    if (
      checked &&
      !nomRsf.trim()
    ) {
      return Swal.fire(
        "Error",
        "Campo nombre RSF no puede estar vacío",
        "error"
      );
    }

    if (
      checked &&
      !dirRsf.trim()
    ) {
      return Swal.fire(
        "Error",
        "Campo Dirección RSF no puede estar vacío",
        "error"
      );
    }

    if (
      checked &&
      !String(telRsf || "").trim()
    ) {
      return Swal.fire(
        "Error",
        "Campo teléfono RSF no puede estar vacío",
        "error"
      );
    }

    setConfirmCliModal(true);
  };

  const guardarCli = async (e) => {
    e.preventDefault();

    setSavingCli(true);

    try {
      const ruts =
        rut.toUpperCase().trim();

      const nom =
        nombre.toUpperCase().trim();

      const dir =
        direccion.toUpperCase().trim();

      const corr =
        correo.toLowerCase().trim();

      await AgregarClientesDb({
        emp_id: users.emp_id,
        rut: ruts,
        nombre: nom,
        direccion: dir,

        fnaci: nacim
          ? new Date(nacim)
          : null,

        telefono,
        region,
        comuna,
        correo: corr,

        nomrsf: nomRsf
          .toUpperCase()
          .trim(),

        dirrsf: dirRsf
          .toUpperCase()
          .trim(),

        telrsf: String(
          telRsf || ""
        ).trim(),

        userAdd:
          user?.email || "",

        userMod:
          user?.email || "",

        fechaAdd,
        fechaMod,
      });

      setEntidad(nom);
      setRut(ruts);
      setDireccion(dir);
      setCorreo(corr);

      setConfirmCliModal(false);
      setOpenModalCli(false);
      setBtnGuardarCab(false);

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "exito",
        mensaje:
          "Cliente registrado exitosamente",
      });

      setFlag((v) => !v);
    } catch (err) {
      Swal.fire(
        "Error",
        err?.message || String(err),
        "error"
      );
    } finally {
      setSavingCli(false);
    }
  };

  // ============================================================
  // CABECERA INGRESO
  // ============================================================

  const ingresoCab = async (e) => {
    e.preventDefault();

    cambiarEstadoAlerta(false);
    cambiarAlerta({});

    const cli = query(
      collection(db, "clientes"),
      where(
        "emp_id",
        "==",
        users.emp_id
      ),
      where(
        "rut",
        "==",
        rut
      )
    );

    const rutCli =
      await getDocs(cli);

    const expresionRegularRut =
      /^[0-9]+[-|‐]{1}[0-9kK]{1}$/;

    const r =
      (rut || "").trim();

    if (!r) {
      return Swal.fire(
        "Error",
        "Campo Rut no puede estar vacío",
        "error"
      );
    }

    if (
      !expresionRegularRut.test(r)
    ) {
      return Swal.fire(
        "Error",
        "Formato incorrecto de rut. Sin puntos, solo guión",
        "error"
      );
    }

    const temp =
      r.split("-");

    let digito =
      temp[1];

    if (
      digito === "k" ||
      digito === "K"
    ) {
      digito = -1;
    }

    const validaR =
      validarRut(r);

    if (
      validaR !==
      parseInt(digito, 10)
    ) {
      return Swal.fire(
        "Error",
        "Rut no válido",
        "error"
      );
    }

    if (
      rutCli.docs.length === 0
    ) {
      Swal.fire(
        "Error",
        "No existe rut de Cliente",
        "error"
      );

      setOpenModalCli(true);

      return;
    }

    setSavingCab(true);

    try {
      const nuevoFolio =
        await correlativos(
          users.emp_id,
          "ingresosst"
        );

      setFolio(nuevoFolio);

      const fechaInSt =
        new Date(date);

      await IngresoStCabDB({
        folio: nuevoFolio,
        rut,
        entidad,
        telefono,
        direccion,
        correo,
        date: fechaInSt,

        nacim: nacim
          ? new Date(nacim)
          : null,

        confirmado: false,
        estado: "POR CONFIRMAR",
        estado_servicio: "",
        tecnico: "",
        fecha_out: "",
        familia: "",
        tipo: "",
        marca: "",
        modelo: "",
        serie: "",
        servicio: "",
        servicionew: "",
        fecha_servicionew: "",
        observaciones: "",
        horamaquina: "",
        enproceso: 0,

        userAdd:
          user?.email || "",

        userMod:
          user?.email || "",

        fechaAdd,
        fechaMod,
        emp_id: users.emp_id,
      });

      setClienteLocked(true);

      setBtnGuardarCab(true);
      setBtnValidarDet(false);

      setMostrarInfoEq(true);

      setActiveCli(false);
      setActiveEq(true);
      setActiveTest(false);

      setStep(2);

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "exito",
        mensaje:
          "Cabecera registrada. Continúa con el equipo.",
      });

      setFlag((v) => !v);
    } catch (err) {
      Swal.fire(
        "Error",
        err?.message || String(err),
        "error"
      );
    } finally {
      setSavingCab(false);
    }
  };

  // ============================================================
  // BUSCAR BAJA ST
  // ============================================================

  const buscarBajaSTActiva =
    async (numeroSerie) => {
      if (
        !users?.emp_id ||
        !String(
          numeroSerie || ""
        ).trim()
      ) {
        return null;
      }

      const serieBuscar =
        String(
          numeroSerie || ""
        )
          .trim()
          .toUpperCase();

      const qBaja = query(
        collection(
          db,
          "bajaEquipos"
        ),

        where(
          "emp_id",
          "==",
          users.emp_id
        ),

        where(
          "serie",
          "==",
          serieBuscar
        ),

        where(
          "tipo_baja",
          "==",
          "BAJA_ST"
        ),

        where(
          "activo",
          "==",
          true
        ),

        where(
          "bloquea_ingreso_st",
          "==",
          true
        )
      );

      const snapBaja =
        await getDocs(qBaja);

      if (snapBaja.empty) {
        return null;
      }

      const d =
        snapBaja.docs[0];

      return {
        id: d.id,
        ...d.data(),
      };
    };

  // ============================================================
  // VALIDAR EQUIPO
  // ============================================================

  const validarDet = async (e) => {
    e.preventDefault();

    cambiarEstadoAlerta(false);
    cambiarAlerta({});

    const serieNormalizada =
      String(serie || "")
        .trim()
        .toUpperCase();

    /*
     * Comparación normalizada.
     */
    const existeSerie =
      (existeCliSerie || []).filter(
        (x) =>
          x.rut === rut &&
          String(
            x.serie || ""
          )
            .trim()
            .toUpperCase() ===
          serieNormalizada
      );

    setExisteSerie2(
      existeSerie
    );

    if (
      !nomFamilia ||
      nomFamilia ===
      "Selecciona Opción:"
    ) {
      return Swal.fire(
        "Error",
        "Seleccione una Familia",
        "error"
      );
    }

    if (
      !nomTipo ||
      nomTipo ===
      "Selecciona Opción:"
    ) {
      return Swal.fire(
        "Error",
        "Seleccione un Tipo de equipamiento",
        "error"
      );
    }

    if (
      !nomMarca ||
      nomMarca ===
      "Selecciona Opción:"
    ) {
      return Swal.fire(
        "Error",
        "Seleccione una Marca",
        "error"
      );
    }

    if (
      !nomModelo ||
      nomModelo ===
      "Selecciona Opción:"
    ) {
      return Swal.fire(
        "Error",
        "Seleccione un Modelo",
        "error"
      );
    }

    if (!serieNormalizada) {
      return Swal.fire(
        "Error",
        "Campo Serie no puede estar vacío",
        "error"
      );
    }

    if (
      !servicio ||
      servicio ===
      "Selecciona Opción:"
    ) {
      return Swal.fire(
        "Error",
        "Seleccione un Tipo de Servicio",
        "error"
      );
    }

    // ========================================================
    // VALIDAR PROTOCOLO
    // ========================================================

    /*
     * CORRECCIÓN:
     *
     * También la cabecera del protocolo debe corresponder a:
     *
     * EMPRESA + FAMILIA + TIPO
     */
    const protCab = query(
      collection(
        db,
        "protocolostestcab"
      ),

      where(
        "emp_id",
        "==",
        users.emp_id
      ),

      where(
        "familia",
        "==",
        nomFamilia
      ),

      where(
        "tipo",
        "==",
        nomTipo
      ),

      where(
        "confirmado",
        "==",
        true
      )
    );

    const existeprot =
      await getDocs(protCab);

    // ========================================================
    // VALIDAR BAJA ST
    // ========================================================

    const bajaST =
      await buscarBajaSTActiva(
        serieNormalizada
      );

    if (bajaST) {
      const fechaBaja =
        bajaST.fechabaja?.toDate
          ? moment(
            bajaST.fechabaja.toDate()
          ).format("DD/MM/YYYY")
          : "Sin fecha";

      const folioBaja =
        bajaST.folio_oe ||
        bajaST.folio ||
        "Sin información";

      const motivo =
        bajaST.observaciones ||
        bajaST.irreparable ||
        "Equipo dado de baja para atención en Servicio Técnico.";

      await Swal.fire({
        icon: "error",

        title:
          "Equipo con Baja de Servicio Técnico",

        html: `
          <div style="text-align:left">
            <p>
              El equipo con serie
              <strong>${serieNormalizada}</strong>
              posee una Baja ST activa.
            </p>

            <hr />

            <p>
              <strong>Orden de Baja:</strong>
              ${folioBaja}
            </p>

            <p>
              <strong>Fecha de Baja:</strong>
              ${fechaBaja}
            </p>

            <p>
              <strong>Motivo:</strong><br/>
              ${motivo}
            </p>

            <hr />

            <p style="color:#db2828;font-weight:bold;">
              Este equipo no puede ser recepcionado nuevamente
              por LogisticMedST.
            </p>
          </div>
        `,

        confirmButtonText:
          "Aceptar",
      });

      return;
    }

    if (
      existeSerie.length > 0
    ) {
      setSeriePendienteModal(
        true
      );

      return;
    }

    if (
      existeprot.docs.length ===
      0
    ) {
      return Swal.fire(
        "Error",
        `No existe un Test de Ingreso confirmado para ${nomFamilia} / ${nomTipo}. Favor crear o confirmar el protocolo.`,
        "error"
      );
    }

    setSavingDet(true);

    try {
      const hor =
        horaMaquina === ""
          ? 0
          : Number(horaMaquina);

      const cabQ = query(
        collection(
          db,
          "ingresostcab"
        ),

        where(
          "emp_id",
          "==",
          users.emp_id
        ),

        where(
          "confirmado",
          "==",
          false
        ),

        where(
          "folio",
          "==",
          folio
        ),

        where(
          "rut",
          "==",
          rut
        )
      );

      const cabSnap =
        await getDocs(cabQ);

      const existeCab =
        cabSnap.docs.map((d) => ({
          ...d.data(),
          id: d.id,
        }));

      if (
        !existeCab?.[0]?.id
      ) {
        throw new Error(
          "No se encontró cabecera en proceso."
        );
      }

      if (
        existeCab.length > 1
      ) {
        throw new Error(
          "Existe más de una cabecera en proceso para el mismo folio y RUT."
        );
      }

      await UpdateIngresoStCabDB({
        id: existeCab[0].id,
        familia: nomFamilia,
        tipo: nomTipo,
        marca: nomMarca,
        modelo: nomModelo,
        serie: serieNormalizada,
        servicio,
        observaciones: "",
        horamaquina: hor,
        fechaMod: new Date(),
      });

      /*
       * CORRECCIÓN:
       *
       * Antes:
       *
       *   consultarprot(nomTipo)
       *
       * Ahora:
       *
       *   consultarprot(nomFamilia, nomTipo)
       */
      await consultarprot(
        nomFamilia,
        nomTipo
      );

      setSerie(
        serieNormalizada
      );

      setEquipoLocked(true);

      setBtnValidarDet(true);
      setBtnValidarTest(false);

      setMostrarTest(true);

      setActiveCli(false);
      setActiveEq(false);
      setActiveTest(true);

      setStep(3);

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "exito",
        mensaje:
          "Equipo registrado. Completa el Test.",
      });

      setFlag((v) => !v);
    } catch (err) {
      Swal.fire(
        "Error",
        err?.message || String(err),
        "error"
      );
    } finally {
      setSavingDet(false);
    }
  };

  // ============================================================
  // TEST
  // ============================================================

  const handleButtonClick = (
    itemId,
    option
  ) => {
    setProtocolo((prev) =>
      prev.map((it) =>
        it.id === itemId
          ? {
            ...it,
            valorsi:
              option === "SI",
            valorno:
              option === "NO",
          }
          : it
      )
    );
  };

  const handleButtonClickg = (
    itemId,
    option
  ) => {
    setTestG((prev) =>
      prev.map((it) =>
        it.id === itemId
          ? {
            ...it,
            valorsi:
              option === "SI",

            valorno:
              option === "NO",

            revision:
              option === "REV",
          }
          : it
      )
    );
  };

  const validarTest = async (
    e
  ) => {
    e.preventDefault();

    /*
     * No permitir abrir nuevamente confirmación
     * mientras se está procesando.
     */
    if (
      savingTest ||
      confirmandoTestRef.current
    ) {
      return;
    }

    checktest.current =
      (protocolo || []).filter(
        (x) =>
          !x.valorsi &&
          !x.valorno
      );

    checktestg.current =
      (testG || []).filter(
        (x) =>
          !x.valorsi &&
          !x.valorno &&
          !x.revision
      );

    if (
      protocolo.length === 0
    ) {
      return Swal.fire(
        "Atención",
        "No existe un Test de Ingreso cargado para esta orden.",
        "warning"
      );
    }

    if (
      checktest.current.length >
      0
    ) {
      return Swal.fire(
        "Atención",
        "Debes seleccionar todos los items del Test de Ingreso.",
        "warning"
      );
    }

    if (
      (servicio ===
        "EVALUACION Y DIAGNOSTICO" ||
        servicio ===
        "EVALUACION POR GARANTIA") &&
      checktestg.current.length >
      0
    ) {
      return Swal.fire(
        "Atención",
        "Debes seleccionar todos los items del Test de Garantía.",
        "warning"
      );
    }

    /*
     * No dependemos de que setObs sea aplicado
     * antes de guardar. guardarTest vuelve a calcular
     * observacionesFinales.
     */
    if (!obs.trim()) {
      setObs(
        "Sin Observaciones"
      );
    }

    setConfirmTestModal(true);
  };

  // ============================================================
  // GUARDAR Y CONFIRMAR TEST
  // ============================================================

  const guardarTest = async () => {
    /*
     * ==========================================================
     * PROTECCIÓN 1: LOCK SINCRÓNICO
     * ==========================================================
     *
     * Aunque el usuario haga doble click antes del siguiente
     * render de React, solamente la primera llamada continúa.
     */
    if (
      confirmandoTestRef.current
    ) {
      return;
    }

    confirmandoTestRef.current =
      true;

    setSavingTest(true);

    try {
      if (!users?.emp_id) {
        throw new Error(
          "No se pudo identificar la empresa del usuario."
        );
      }

      if (!folio || !rut) {
        throw new Error(
          "La orden en proceso no tiene folio o RUT válido."
        );
      }

      if (
        !protocolo?.length
      ) {
        throw new Error(
          "No existe un Test de Ingreso cargado para esta orden."
        );
      }

      /*
       * Localizamos primero la referencia de la cabecera.
       *
       * No usamos confirmado=false aquí porque la comprobación
       * crítica se hará DENTRO de runTransaction.
       */
      const cabQ = query(
        collection(
          db,
          "ingresostcab"
        ),

        where(
          "emp_id",
          "==",
          users.emp_id
        ),

        where(
          "folio",
          "==",
          folio
        ),

        where(
          "rut",
          "==",
          rut
        )
      );

      const cabSnap =
        await getDocs(cabQ);

      if (cabSnap.empty) {
        throw new Error(
          "No se encontró la cabecera de la orden en proceso."
        );
      }

      /*
       * Si por cualquier corrupción previa existieran dos
       * cabeceras iguales, no elegimos arbitrariamente una.
       */
      if (
        cabSnap.size > 1
      ) {
        throw new Error(
          "Se encontró más de una cabecera para el mismo folio y RUT. No se confirmó la orden."
        );
      }

      const cabDoc =
        cabSnap.docs[0];

      const idCab =
        cabDoc.id;

      const cabRef = doc(
        db,
        "ingresostcab",
        idCab
      );

      const fechaConfirmacion =
        new Date();

      const correoUsuario =
        user?.email ||
        users?.correo ||
        "";

      const observacionesFinales =
        obs.trim() ||
        "Sin Observaciones";

      /*
       * ========================================================
       * TRANSACCIÓN FIRESTORE
       * ========================================================
       *
       * Esta es la corrección fundamental.
       *
       * Antes:
       *
       *  1. getDocs cabecera confirmado=false
       *  2. batch testingreso
       *  3. batch.commit()
       *  4. updateDoc cabecera confirmado=true
       *
       * Había una ventana en que dos ejecuciones podían leer
       * confirmado=false.
       *
       * Además, si el batch terminaba y el updateDoc fallaba,
       * el usuario podía reintentar y volver a crear todos los
       * documentos.
       *
       * Ahora:
       *
       *  - se lee la cabecera dentro de runTransaction
       *  - se verifica confirmado
       *  - se escriben los tests
       *  - se confirma la cabecera
       *
       * TODO ocurre en una sola transacción.
       */
      await runTransaction(
        db,
        async (transaction) => {
          const cabActualSnap =
            await transaction.get(
              cabRef
            );

          if (
            !cabActualSnap.exists()
          ) {
            throw new Error(
              "La cabecera de la orden ya no existe."
            );
          }

          const cabActual =
            cabActualSnap.data();

          if (
            cabActual.emp_id !==
            users.emp_id
          ) {
            throw new Error(
              "La orden no pertenece a la empresa del usuario."
            );
          }

          /*
           * ====================================================
           * PROTECCIÓN 2: ESTADO TRANSACCIONAL
           * ====================================================
           *
           * Si dos navegadores intentan confirmar al mismo
           * tiempo, Firestore reintentará la transacción.
           *
           * El segundo terminará viendo confirmado=true y será
           * rechazado.
           */
          if (
            cabActual.confirmado ===
            true
          ) {
            throw new Error(
              "Esta orden ya fue confirmada. Se bloqueó una segunda ejecución para evitar duplicados."
            );
          }

          /*
           * ====================================================
           * TEST DE INGRESO
           * ====================================================
           *
           * CORRECCIÓN:
           *
           * Antes:
           *
           *   const nuevo = doc(collection(...))
           *
           * generaba un ID aleatorio cada vez.
           *
           * Ahora:
           *
           *   idCab + id del protocolo
           *
           * produce siempre el MISMO documento.
           *
           * Ejemplo:
           *
           * testingreso/
           *   abcOrden_xyzItemProtocolo
           *
           * Por lo tanto, incluso ante un retry de Firestore,
           * no se puede generar una segunda copia física del
           * mismo item.
           */
          protocolo.forEach(
            (itemProtocolo) => {
              if (
                !itemProtocolo?.id
              ) {
                throw new Error(
                  "Existe un ítem de protocolo sin identificador."
                );
              }

              const testRef =
                doc(
                  db,
                  "testingreso",
                  `${idCab}_${itemProtocolo.id}`
                );

              transaction.set(
                testRef,
                {
                  id_cab_inst:
                    idCab,

                  folio:
                    cabActual.folio,

                  nombretest:
                    itemProtocolo.nombre ||
                    "",

                  familia:
                    itemProtocolo.familia ||
                    nomFamilia,

                  item:
                    itemProtocolo.item ||
                    "",

                  item_id:
                    itemProtocolo.item_id ||
                    itemProtocolo.id,

                  /*
                   * Guardamos además el ID exacto del documento
                   * que originó este test.
                   */
                  protocolo_id:
                    itemProtocolo.id,

                  valorsi:
                    !!itemProtocolo.valorsi,

                  valorno:
                    !!itemProtocolo.valorno,

                  useradd:
                    correoUsuario,

                  usermod:
                    correoUsuario,

                  fechaadd:
                    fechaConfirmacion,

                  fechamod:
                    fechaConfirmacion,

                  emp_id:
                    users.emp_id,
                }
              );
            }
          );

          /*
           * ====================================================
           * TEST DE GARANTÍA
           * ====================================================
           */
          if (
            servicio ===
            "EVALUACION Y DIAGNOSTICO" ||
            servicio ===
            "EVALUACION POR GARANTIA"
          ) {
            testG.forEach(
              (itemGarantia) => {
                if (
                  !itemGarantia?.id
                ) {
                  throw new Error(
                    "Existe un ítem de garantía sin identificador."
                  );
                }

                /*
                 * También usamos ID determinístico.
                 */
                const garantiaRef =
                  doc(
                    db,
                    "testevaluacion",
                    `${idCab}_${itemGarantia.id}`
                  );

                transaction.set(
                  garantiaRef,
                  {
                    id_cab_inst:
                      idCab,

                    folio:
                      cabActual.folio,

                    item:
                      itemGarantia.nombre ||
                      "",

                    item_id:
                      itemGarantia.id,

                    valorsi:
                      !!itemGarantia.valorsi,

                    valorno:
                      !!itemGarantia.valorno,

                    revision:
                      !!itemGarantia.revision,

                    useradd:
                      correoUsuario,

                    usermod:
                      correoUsuario,

                    fechaadd:
                      fechaConfirmacion,

                    fechamod:
                      fechaConfirmacion,

                    emp_id:
                      users.emp_id,
                  }
                );
              }
            );
          }

          /*
           * ====================================================
           * CONFIRMAR CABECERA
           * ====================================================
           *
           * Forma parte de LA MISMA transacción.
           */
          transaction.update(
            cabRef,
            {
              confirmado: true,

              observaciones:
                observacionesFinales,

              estado:
                "INGRESADO",

              usermod:
                correoUsuario,

              fechamod:
                fechaConfirmacion,
            }
          );
        }
      );

      /*
       * ========================================================
       * CÓDIGO DE ENTREGA
       * ========================================================
       *
       * CodigoEntregaDB es un helper externo y por eso no forma
       * parte de esta transacción.
       *
       * IMPORTANTE:
       *
       * Si falla, NO consideramos fallida la confirmación del
       * test, porque esa transacción ya terminó correctamente.
       *
       * Esto evita que el operador vuelva a confirmar la orden
       * intentando reparar un problema secundario y genere
       * inconsistencias.
       */
      let codigoEntregaOK = true;

      try {
        await CodigoEntregaDB({
          id: idCab,

          folio:
            cabDoc.data().folio,

          codigo: 0,

          nombre_out: "",
          correo_out: "",

          userAdd:
            correoUsuario,

          userMod:
            correoUsuario,

          fechaAdd:
            fechaConfirmacion,

          fechaMod:
            fechaConfirmacion,

          emp_id:
            users.emp_id,
        });
      } catch (codigoError) {
        codigoEntregaOK = false;

        console.error(
          "Error al crear código de entrega:",
          codigoError
        );
      }

      setConfirmTestModal(false);

      if (!codigoEntregaOK) {
        await Swal.fire(
          "Orden confirmada",
          "La orden y el test fueron confirmados correctamente, pero no fue posible crear el registro de código de entrega. Debe revisarse ese registro.",
          "warning"
        );
      } else {
        await Swal.fire(
          "OK",
          "Documento confirmado exitosamente.",
          "success"
        );
      }

      resetAll();
    } catch (err) {
      const mensaje =
        err?.message ||
        String(err);

      /*
       * Si otro proceso alcanzó a confirmar primero,
       * informamos al usuario y recargamos el estado.
       */
      if (
        mensaje.includes(
          "ya fue confirmada"
        )
      ) {
        setConfirmTestModal(
          false
        );

        await Swal.fire(
          "Atención",
          mensaje,
          "warning"
        );

        resetAll();
      } else {
        await Swal.fire(
          "Error",
          mensaje,
          "error"
        );
      }
    } finally {
      confirmandoTestRef.current =
        false;

      setSavingTest(false);
    }
  };

  // ============================================================
  // ANULAR
  // ============================================================

  const handleAnular = (id) => {
    setItemAnular(id);
    setConfirmAnularModal(true);
  };

  const anular = async () => {
    try {
      if (
        !users?.emp_id ||
        !itemAnular
      ) {
        return;
      }

      /*
       * CORRECCIÓN:
       *
       * Antes testingreso se consultaba solamente por
       * id_cab_inst.
       *
       * Ahora también restringimos por empresa.
       */
      const qIngreso = query(
        collection(
          db,
          "testingreso"
        ),

        where(
          "emp_id",
          "==",
          users.emp_id
        ),

        where(
          "id_cab_inst",
          "==",
          itemAnular
        )
      );

      /*
       * CORRECCIÓN:
       *
       * Antes al anular NO se eliminaba testevaluacion.
       */
      const qEvaluacion = query(
        collection(
          db,
          "testevaluacion"
        ),

        where(
          "emp_id",
          "==",
          users.emp_id
        ),

        where(
          "id_cab_inst",
          "==",
          itemAnular
        )
      );

      const [
        snapIngreso,
        snapEvaluacion,
      ] = await Promise.all([
        getDocs(qIngreso),
        getDocs(qEvaluacion),
      ]);

      /*
       * Cabecera + eliminación de tests se hace en un mismo batch.
       */
      const batch =
        writeBatch(db);

      batch.update(
        doc(
          db,
          "ingresostcab",
          itemAnular
        ),
        {
          confirmado: true,
          estado: "ANULADO",

          usermod:
            user?.email ||
            users?.correo ||
            "",

          fechamod:
            new Date(),
        }
      );

      snapIngreso.docs.forEach(
        (d) => {
          batch.delete(
            doc(
              db,
              "testingreso",
              d.id
            )
          );
        }
      );

      snapEvaluacion.docs.forEach(
        (d) => {
          batch.delete(
            doc(
              db,
              "testevaluacion",
              d.id
            )
          );
        }
      );

      await batch.commit();

      setConfirmAnularModal(
        false
      );

      Swal.fire(
        "OK",
        "Documento Anulado.",
        "success"
      );

      resetAll();
    } catch (err) {
      Swal.fire(
        "Error",
        err?.message ||
        String(err),
        "error"
      );
    }
  };

  // ============================================================
  // PDF
  // ============================================================

  const pdfver = async (id) => {
    try {
      // ========================================================
      // CABECERA
      // ========================================================

      const datosFiltrados =
        ingresado.filter(
          (x) => x.id === id
        );

      if (
        datosFiltrados.length ===
        0
      ) {
        throw new Error(
          "No se encontró la orden de ingreso."
        );
      }

      setDatosPdf(
        datosFiltrados
      );

      // ========================================================
      // TEST DE INGRESO
      // ========================================================

      const qTest = query(
        collection(
          db,
          "testingreso"
        ),

        where(
          "emp_id",
          "==",
          users.emp_id
        ),

        where(
          "id_cab_inst",
          "==",
          id
        )
      );

      const snapTest =
        await getDocs(qTest);

      const existeTest =
        snapTest.docs.map((d) => ({
          ...d.data(),
          id: d.id,
        }));

      existeTest.sort(
        (a, b) => {
          const fa =
            a.fechamod
              ?.toMillis?.() ?? 0;

          const fb =
            b.fechamod
              ?.toMillis?.() ?? 0;

          return fa - fb;
        }
      );

      setTest(existeTest);

      // ========================================================
      // TEST GARANTÍA
      // ========================================================

      const qGarantia = query(
        collection(
          db,
          "testevaluacion"
        ),

        where(
          "emp_id",
          "==",
          users.emp_id
        ),

        where(
          "id_cab_inst",
          "==",
          id
        )
      );

      const snapGarantia =
        await getDocs(qGarantia);

      const existeTG =
        snapGarantia.docs.map(
          (d) => ({
            ...d.data(),
            id: d.id,
          })
        );

      existeTG.sort(
        (a, b) => {
          const fa =
            a.fechamod
              ?.toMillis?.() ?? 0;

          const fb =
            b.fechamod
              ?.toMillis?.() ?? 0;

          return fa - fb;
        }
      );

      setTestGpdf(existeTG);

      // ========================================================
      // TÉCNICO QUE CONFIRMÓ
      // ========================================================

      const correoTecnico =
        String(
          datosFiltrados[0]
            ?.usermod ||
          datosFiltrados[0]
            ?.userMod ||
          datosFiltrados[0]
            ?.useradd ||
          datosFiltrados[0]
            ?.userAdd ||
          ""
        )
          .trim()
          .toLowerCase();

      let usuarioPdf = [];

      if (correoTecnico) {
        usuarioPdf =
          usuarioIngreso.filter(
            (u) =>
              String(
                u.correo || ""
              )
                .trim()
                .toLowerCase() ===
              correoTecnico
          );

        /*
         * CORRECCIÓN MULTIEMPRESA:
         * fallback también restringido por emp_id.
         */
        if (
          usuarioPdf.length ===
          0
        ) {
          const qUsuario =
            query(
              collection(
                db,
                "usuarios"
              ),

              where(
                "emp_id",
                "==",
                users.emp_id
              ),

              where(
                "correo",
                "==",
                correoTecnico
              )
            );

          const snapUsuario =
            await getDocs(
              qUsuario
            );

          usuarioPdf =
            snapUsuario.docs.map(
              (d) => ({
                ...d.data(),
                id: d.id,
              })
            );
        }
      }

      if (
        usuarioPdf.length === 0
      ) {
        usuarioPdf = [
          {
            nombre: "Sistema",
            apellido:
              "LogisticMed",
            correo:
              correoTecnico,
          },
        ];
      }

      setUsersAdd(usuarioPdf);
      setOpenPdf(true);
    } catch (error) {
      console.error(
        "Error PDF:",
        error
      );

      Swal.fire(
        "Error",
        error.message ||
        "No fue posible abrir el PDF.",
        "error"
      );
    }
  };

  const descargarPdf = async (
    id,
    folioPdf
  ) => {
    try {
      // ========================================================
      // CABECERA
      // ========================================================

      const datosPdf =
        ingresado.filter(
          (x) => x.id === id
        );

      if (
        datosPdf.length === 0
      ) {
        throw new Error(
          "No se encontró la orden."
        );
      }

      // ========================================================
      // TEST INGRESO
      // ========================================================

      const qTest = query(
        collection(
          db,
          "testingreso"
        ),

        where(
          "emp_id",
          "==",
          users.emp_id
        ),

        where(
          "id_cab_inst",
          "==",
          id
        )
      );

      const snapTest =
        await getDocs(qTest);

      const existeTest =
        snapTest.docs.map((d) => ({
          ...d.data(),
          id: d.id,
        }));

      existeTest.sort(
        (a, b) => {
          const fa =
            a.fechamod
              ?.toMillis?.() ?? 0;

          const fb =
            b.fechamod
              ?.toMillis?.() ?? 0;

          return fa - fb;
        }
      );

      // ========================================================
      // TEST GARANTÍA
      // ========================================================

      const qGarantia = query(
        collection(
          db,
          "testevaluacion"
        ),

        where(
          "emp_id",
          "==",
          users.emp_id
        ),

        where(
          "id_cab_inst",
          "==",
          id
        )
      );

      const snapGarantia =
        await getDocs(
          qGarantia
        );

      const existeTG =
        snapGarantia.docs.map(
          (d) => ({
            ...d.data(),
            id: d.id,
          })
        );

      existeTG.sort(
        (a, b) => {
          const fa =
            a.fechamod
              ?.toMillis?.() ?? 0;

          const fb =
            b.fechamod
              ?.toMillis?.() ?? 0;

          return fa - fb;
        }
      );

      // ========================================================
      // TÉCNICO
      // ========================================================

      const correoTecnico =
        String(
          datosPdf[0]
            ?.usermod ||
          datosPdf[0]
            ?.userMod ||
          datosPdf[0]
            ?.useradd ||
          datosPdf[0]
            ?.userAdd ||
          ""
        )
          .trim()
          .toLowerCase();

      let usuarioAdd = [];

      if (correoTecnico) {
        usuarioAdd =
          usuarioIngreso.filter(
            (u) =>
              String(
                u.correo || ""
              )
                .trim()
                .toLowerCase() ===
              correoTecnico
          );

        if (
          usuarioAdd.length ===
          0
        ) {
          const qUsuario =
            query(
              collection(
                db,
                "usuarios"
              ),

              where(
                "emp_id",
                "==",
                users.emp_id
              ),

              where(
                "correo",
                "==",
                correoTecnico
              )
            );

          const snapUsuario =
            await getDocs(
              qUsuario
            );

          usuarioAdd =
            snapUsuario.docs.map(
              (d) => ({
                ...d.data(),
                id: d.id,
              })
            );
        }
      }

      if (
        usuarioAdd.length === 0
      ) {
        usuarioAdd = [
          {
            nombre: "Sistema",
            apellido:
              "LogisticMed",
            correo:
              correoTecnico,
          },
        ];
      }

      const blob = await pdf(
        <SimplePDF
          props={datosPdf}
          test={existeTest}
          testGpdf={existeTG}
          usuario={usuarioAdd}
          empresa={users.emp_id}
        />
      ).toBlob();

      saveAs(
        blob,
        `Orden Ingreso N.${folioPdf}.pdf`
      );
    } catch (error) {
      console.error(
        "Error descarga PDF:",
        error
      );

      Swal.fire(
        "Error",
        error.message ||
        "No fue posible descargar el PDF.",
        "error"
      );
    }
  };

  const fechaDate = (fecha) => {
    if (!fecha?.seconds) return;

    const ms = fecha.seconds * 1000;
    const fechas = new Date(ms);
    const formato = fechas.toISOString().slice(0, 16);

    setDate(formato);
  };
  // ============================================================
  // CARGAS INICIALES
  // ============================================================

  useEffect(() => {
    if (!users?.emp_id) {
      return;
    }

    getFamilia();
    getMarca();
    testGarantia();
  }, [users?.emp_id]);

  useEffect(() => {
    if (!users?.emp_id) {
      return;
    }

    getTipo();
  }, [
    users?.emp_id,
    nomFamilia,
  ]);

  useEffect(() => {
    if (!users?.emp_id) {
      return;
    }

    getModelo();
  }, [
    users?.emp_id,
    nomMarca,
  ]);

  useEffect(() => {
    if (!users?.emp_id) {
      return;
    }

    consultarCab();
    consultarIn();
    consultarClientes();
    consultarUsuario();
  }, [
    users?.emp_id,
    users?.correo,
  ]);

  useEffect(() => {
    if (!users?.emp_id) {
      return;
    }

    consultarCab();
    consultarIn();
    getNoCerradas();
  }, [
    flag,
    users?.emp_id,
  ]);

  // ============================================================
  // UI OPTIONS
  // ============================================================

  const familiaOptions =
    familia.map((d) => ({
      key: d.id,
      text: d.familia,
      value: d.familia,
    }));

  const tipoOptions =
    tipo.map((d) => ({
      key: d.id,
      text: d.tipo,
      value: d.tipo,
    }));

  const marcaOptions =
    marca.map((d) => ({
      key: d.id,
      text: d.marca,
      value: d.marca,
    }));

  const modeloOptions =
    modelo.map((d) => ({
      key: d.id,
      text: d.modelo,
      value: d.modelo,
    }));

  const servicioOptions =
    Servicio.map((d) => ({
      key: d.key,
      text: d.text,
      value: d.text,
    }));

  const savingAny =
    savingCab ||
    savingDet ||
    savingCli ||
    savingTest;
  // ============================================================
  // RETURN
  // ============================================================

  return (
    <Container
      fluid
      style={{
        background: "#f8fafc",
        minHeight: "100vh",
        padding: "24px 14px 40px",
      }}
    >
      <Container fluid style={{ maxWidth: 1400 }}>

        {/* ========================================================
          CABECERA
      ======================================================== */}

        <Segment
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,.04)",
            marginBottom: 18,
          }}
        >
          <Grid stackable verticalAlign="middle">
            <Grid.Column width={11}>
              <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <div
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: 10,
                    background: "#e6fffb",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Icon
                    name="clipboard outline"
                    color="teal"
                    size="large"
                    style={{ margin: 0 }}
                  />
                </div>

                <div>
                  <Header
                    as="h2"
                    style={{
                      margin: 0,
                      color: "#1f2937",
                    }}
                  >
                    Orden de Ingreso

                    {folio && (
                      <span
                        style={{
                          marginLeft: 10,
                          fontSize: 17,
                          fontWeight: 600,
                          color: "#6b7280",
                        }}
                      >
                        N° {folio}
                      </span>
                    )}
                  </Header>

                  <div
                    style={{
                      color: "#6b7280",
                      marginTop: 4,
                    }}
                  >
                    Recepción y evaluación inicial de equipos en Servicio Técnico
                  </div>
                </div>
              </div>
            </Grid.Column>

            <Grid.Column width={5} textAlign="right">
              <Label basic color="teal" size="large">
                <Icon name="wrench" />
                Servicio Técnico
              </Label>
            </Grid.Column>
          </Grid>
        </Segment>

        {/* ========================================================
          PASOS
      ======================================================== */}

        <Segment
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: 12,
            boxShadow: "none",
            marginBottom: 18,
          }}
        >
          <Step.Group fluid ordered size="small">
            <Step
              active={step === 1}
              completed={step > 1}
            >
              <Step.Content>
                <Step.Title>
                  Cliente
                </Step.Title>

                <Step.Description>
                  {clienteLocked
                    ? "Datos registrados"
                    : "Identificación"}
                </Step.Description>
              </Step.Content>
            </Step>

            <Step
              active={step === 2}
              completed={step > 2}
              disabled={step < 2}
            >
              <Step.Content>
                <Step.Title>
                  Equipo
                </Step.Title>

                <Step.Description>
                  {equipoLocked
                    ? "Equipo registrado"
                    : step >= 2
                      ? "Datos técnicos"
                      : "Pendiente"}
                </Step.Description>
              </Step.Content>
            </Step>

            <Step
              active={step === 3}
              disabled={step < 3}
            >
              <Step.Content>
                <Step.Title>
                  Test de Ingreso
                </Step.Title>

                <Step.Description>
                  {step >= 3
                    ? "Evaluación"
                    : "Pendiente"}
                </Step.Description>
              </Step.Content>
            </Step>
          </Step.Group>
        </Segment>

        {/* ========================================================
          1. CLIENTE
      ======================================================== */}

        <Segment
          style={{
            padding: 0,
            borderRadius: 12,
            overflow: "visible",
            border: activeCli
              ? "2px solid #00b5ad"
              : "1px solid #e5e7eb",
            boxShadow: activeCli
              ? "0 3px 12px rgba(0,181,173,.10)"
              : "0 2px 6px rgba(0,0,0,.03)",
            marginBottom: 16,
          }}
        >
          <Accordion fluid>
            <Accordion.Title
              active={activeCli}
              onClick={() =>
                setActiveCli((v) => !v)
              }
              style={{
                padding: "15px 18px",
                cursor: "pointer",
                borderRadius: activeCli
                  ? "12px 12px 0 0"
                  : "12px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <div
                    style={{
                      width: 34,
                      height: 34,
                      borderRadius: 8,
                      background: "#e6fffb",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon
                      name="user outline"
                      color="teal"
                      style={{ margin: 0 }}
                    />
                  </div>

                  <div>
                    <strong style={{ fontSize: 16 }}>
                      1. Información del Cliente
                    </strong>

                    <div
                      style={{
                        color: "#6b7280",
                        fontSize: 12,
                        marginTop: 2,
                      }}
                    >
                      Identificación y datos de contacto
                    </div>
                  </div>

                  {clienteLocked && (
                    <Label
                      basic
                      color="teal"
                      size="tiny"
                    >
                      <Icon name="check" />
                      Registrado
                    </Label>
                  )}
                </div>

                <Icon
                  name={
                    activeCli
                      ? "angle up"
                      : "angle down"
                  }
                />
              </div>
            </Accordion.Title>

            <Accordion.Content active={activeCli}>
              <div
                style={{
                  padding: "4px 18px 18px",
                }}
              >
                <Divider />

                <Form>
                  <Grid stackable>
                    <Grid.Row>
                      <Grid.Column width={16}>
                        <Label basic>
                          <Icon name="calendar alternate outline" />
                          Fecha de ingreso:{" "}
                          {moment(date).format("DD/MM/YYYY")}
                        </Label>
                      </Grid.Column>
                    </Grid.Row>

                    <Grid.Row columns={2}>
                      <Grid.Column>
                        <Form.Field>
                          <label>
                            Rut Cliente
                          </label>

                          <BuscadorInput
                            items={clientes}
                            onSelectItem={handleSelectItem}
                            limpiaFormCte={limpiaFormCte}
                            confirmar={
                              clienteLocked ||
                              savingCab
                            }
                            rut={rut}
                          />
                        </Form.Field>
                      </Grid.Column>

                      <Grid.Column>
                        <Form.Input
                          fluid
                          label="Nombre Cliente"
                          value={entidad}
                          readOnly
                          placeholder="Nombre del cliente"
                          icon="user"
                          iconPosition="left"
                        />
                      </Grid.Column>
                    </Grid.Row>

                    <Grid.Row columns={2}>
                      <Grid.Column>
                        <Form.Input
                          fluid
                          label="Teléfono"
                          value={telefono}
                          readOnly
                          placeholder="Teléfono"
                          icon="phone"
                          iconPosition="left"
                        />
                      </Grid.Column>

                      <Grid.Column>
                        <Form.Input
                          fluid
                          label="Dirección"
                          value={direccion}
                          readOnly
                          placeholder="Dirección"
                          icon="map marker alternate"
                          iconPosition="left"
                        />
                      </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                      <Grid.Column width={16}>
                        <Form.Input
                          fluid
                          label="Correo electrónico"
                          value={correo}
                          readOnly
                          placeholder="Email"
                          icon="mail outline"
                          iconPosition="left"
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>

                  <Divider />

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 8,
                      flexWrap: "wrap",
                    }}
                  >
                    <Button
                      basic
                      onClick={resetAll}
                      disabled={savingAny}
                    >
                      <Icon name="plus" />
                      Nueva Orden
                    </Button>

                    <Button
                      color="teal"
                      icon
                      labelPosition="right"
                      onClick={ingresoCab}
                      disabled={
                        btnGuardarCab ||
                        !entidad ||
                        clienteLocked
                      }
                      loading={savingCab}
                    >
                      Continuar
                      <Icon name="arrow right" />
                    </Button>
                  </div>
                </Form>
              </div>
            </Accordion.Content>
          </Accordion>
        </Segment>

        {/* ========================================================
          2. EQUIPO
      ======================================================== */}

        {mostrarInfoEq && (
          <Segment
            style={{
              padding: 0,
              borderRadius: 12,
              overflow: "hidden",
              border: activeCli
                ? "2px solid #00b5ad"
                : "1px solid #e5e7eb",
              boxShadow: activeCli
                ? "0 3px 12px rgba(0,181,173,.10)"
                : "0 2px 6px rgba(0,0,0,.03)",
              marginBottom: 16,
            }}
          >
            <Accordion fluid>
              <Accordion.Title
                active={activeEq}
                onClick={() =>
                  setActiveEq((v) => !v)
                }
                style={{
                  padding: "15px 18px",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <div
                      style={{
                        width: 34,
                        height: 34,
                        borderRadius: 8,
                        background: "#e6fffb",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon
                        name="settings"
                        color="teal"
                        style={{ margin: 0 }}
                      />
                    </div>

                    <div>
                      <strong style={{ fontSize: 16 }}>
                        2. Información del Equipo
                      </strong>

                      <div
                        style={{
                          color: "#6b7280",
                          fontSize: 12,
                          marginTop: 2,
                        }}
                      >
                        Identificación del equipo y servicio solicitado
                      </div>
                    </div>

                    {equipoLocked && (
                      <Label
                        basic
                        color="teal"
                        size="tiny"
                      >
                        <Icon name="check" />
                        Registrado
                      </Label>
                    )}
                  </div>

                  <Icon
                    name={
                      activeEq
                        ? "angle up"
                        : "angle down"
                    }
                  />
                </div>
              </Accordion.Title>

              <Accordion.Content active={activeEq}>
                <div
                  style={{
                    padding: "4px 18px 18px",
                  }}
                >
                  <Divider />

                  <Form>
                    <Grid stackable>
                      <Grid.Row columns={2}>
                        <Grid.Column>
                          <Form.Field>
                            <label>
                              Familia
                            </label>

                            <Dropdown
                              fluid
                              search
                              selection
                              placeholder="Seleccione familia"
                              options={familiaOptions}
                              value={nomFamilia}
                              disabled={
                                equipoLocked ||
                                savingDet
                              }
                              onChange={(e, { value }) => {
                                setNomFamilia(value);
                                setNomTipo("");
                              }}
                            />
                          </Form.Field>
                        </Grid.Column>

                        <Grid.Column>
                          <Form.Field>
                            <label>
                              Tipo
                            </label>

                            <Dropdown
                              fluid
                              search
                              selection
                              placeholder="Seleccione tipo"
                              options={tipoOptions}
                              value={nomTipo}
                              disabled={
                                !nomFamilia ||
                                equipoLocked ||
                                savingDet
                              }
                              onChange={(e, { value }) =>
                                setNomTipo(value)
                              }
                            />
                          </Form.Field>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row columns={2}>
                        <Grid.Column>
                          <Form.Field>
                            <label>
                              Marca
                            </label>

                            <Dropdown
                              fluid
                              search
                              selection
                              placeholder="Seleccione marca"
                              options={marcaOptions}
                              value={nomMarca}
                              disabled={
                                equipoLocked ||
                                savingDet
                              }
                              onChange={(e, { value }) => {
                                setNomMarca(value);
                                setNomModelo("");
                              }}
                            />
                          </Form.Field>
                        </Grid.Column>

                        <Grid.Column>
                          <Form.Field>
                            <label>
                              Modelo
                            </label>

                            <Dropdown
                              fluid
                              search
                              selection
                              placeholder="Seleccione modelo"
                              options={modeloOptions}
                              value={nomModelo}
                              disabled={
                                !nomMarca ||
                                equipoLocked ||
                                savingDet
                              }
                              onChange={(e, { value }) =>
                                setNomModelo(value)
                              }
                            />
                          </Form.Field>
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row columns={2}>
                        <Grid.Column>
                          <Form.Input
                            fluid
                            label="Número de Serie"
                            placeholder="Ingrese número de serie"
                            value={serie}
                            disabled={
                              equipoLocked ||
                              savingDet
                            }
                            onChange={(e) =>
                              setSerie(e.target.value)
                            }
                            icon="barcode"
                            iconPosition="left"
                          />
                        </Grid.Column>

                        <Grid.Column>
                          <Form.Input
                            fluid
                            type="number"
                            label="Horas de Máquina"
                            placeholder="Opcional"
                            value={horaMaquina}
                            disabled={
                              equipoLocked ||
                              savingDet
                            }
                            onChange={(e) =>
                              setHoraMaquina(
                                e.target.value
                              )
                            }
                            icon="clock outline"
                            iconPosition="left"
                          />
                        </Grid.Column>
                      </Grid.Row>

                      <Grid.Row>
                        <Grid.Column width={16}>
                          <Form.Field>
                            <label>
                              Servicio solicitado
                            </label>

                            <Dropdown
                              fluid
                              search
                              selection
                              placeholder="Seleccione servicio"
                              options={servicioOptions}
                              value={servicio}
                              disabled={
                                equipoLocked ||
                                savingDet
                              }
                              onChange={(e, { value }) =>
                                setServicio(value)
                              }
                            />
                          </Form.Field>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>

                    <Divider />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        color="teal"
                        icon
                        labelPosition="right"
                        onClick={validarDet}
                        disabled={
                          btnValidarDet ||
                          equipoLocked
                        }
                        loading={savingDet}
                      >
                        Continuar al Test
                        <Icon name="arrow right" />
                      </Button>
                    </div>
                  </Form>
                </div>
              </Accordion.Content>
            </Accordion>
          </Segment>
        )}

        {/* ========================================================
          3. TEST DE INGRESO
      ======================================================== */}

        {mostrarTest && (
          <Segment
            style={{
              padding: 0,
              borderRadius: 12,
              overflow: "hidden",
              border: activeCli
                ? "2px solid #00b5ad"
                : "1px solid #e5e7eb",
              boxShadow: activeCli
                ? "0 3px 12px rgba(0,181,173,.10)"
                : "0 2px 6px rgba(0,0,0,.03)",
              marginBottom: 16,
            }}
          >
            <Accordion fluid>
              <Accordion.Title
                active={activeTest}
                onClick={() =>
                  setActiveTest((v) => !v)
                }
                style={{
                  padding: "15px 18px",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <div
                      style={{
                        width: 34,
                        height: 34,
                        borderRadius: 8,
                        background: "#e6fffb",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon
                        name="clipboard check"
                        color="teal"
                        style={{ margin: 0 }}
                      />
                    </div>

                    <div>
                      <strong style={{ fontSize: 16 }}>
                        3. Test de Ingreso
                      </strong>

                      <div
                        style={{
                          color: "#6b7280",
                          fontSize: 12,
                          marginTop: 2,
                        }}
                      >
                        Inspección inicial y condición del equipo
                      </div>
                    </div>
                  </div>

                  <Icon
                    name={
                      activeTest
                        ? "angle up"
                        : "angle down"
                    }
                  />
                </div>
              </Accordion.Title>

              <Accordion.Content active={activeTest}>
                <div
                  style={{
                    padding: "4px 18px 18px",
                  }}
                >
                  <Divider />

                  {/* TEST DE INGRESO */}

                  <div style={{ overflowX: "auto" }}>
                    <Table
                      celled
                      compact="very"
                      striped
                      selectable
                    >
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell width={1}>
                            #
                          </Table.HeaderCell>

                          <Table.HeaderCell>
                            Item
                          </Table.HeaderCell>

                          <Table.HeaderCell
                            textAlign="center"
                            width={2}
                          >
                            Sí
                          </Table.HeaderCell>

                          <Table.HeaderCell
                            textAlign="center"
                            width={2}
                          >
                            No
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body>
                        {protocolo.map(
                          (it, idx) => (
                            <Table.Row key={it.id}>
                              <Table.Cell>
                                {idx + 1}
                              </Table.Cell>

                              <Table.Cell
                                style={{
                                  whiteSpace: "normal",
                                }}
                              >
                                {it.item}
                              </Table.Cell>

                              <Table.Cell textAlign="center">
                                <Input
                                  type="checkbox"
                                  checked={!!it.valorsi}
                                  disabled={savingTest}
                                  onChange={() =>
                                    handleButtonClick(
                                      it.id,
                                      "SI"
                                    )
                                  }
                                  style={{
                                    transform: "scale(1.3)",
                                  }}
                                />
                              </Table.Cell>

                              <Table.Cell textAlign="center">
                                <Input
                                  type="checkbox"
                                  checked={!!it.valorno}
                                  disabled={savingTest}
                                  onChange={() =>
                                    handleButtonClick(
                                      it.id,
                                      "NO"
                                    )
                                  }
                                  style={{
                                    transform: "scale(1.3)",
                                  }}
                                />
                              </Table.Cell>
                            </Table.Row>
                          )
                        )}
                      </Table.Body>
                    </Table>
                  </div>

                  {/* TEST GARANTÍA */}

                  {(servicio ===
                    "EVALUACION Y DIAGNOSTICO" ||
                    servicio ===
                    "EVALUACION POR GARANTIA") && (
                      <>
                        <Divider />

                        <Header as="h4">
                          <Icon
                            name="shield alternate"
                            color="teal"
                          />

                          <Header.Content>
                            Test Garantía
                          </Header.Content>
                        </Header>

                        <div
                          style={{
                            overflowX: "auto",
                          }}
                        >
                          <Table
                            celled
                            compact="very"
                            striped
                          >
                            <Table.Header>
                              <Table.Row>
                                <Table.HeaderCell width={1}>
                                  #
                                </Table.HeaderCell>

                                <Table.HeaderCell>
                                  Item
                                </Table.HeaderCell>

                                <Table.HeaderCell
                                  textAlign="center"
                                  width={2}
                                >
                                  Sí
                                </Table.HeaderCell>

                                <Table.HeaderCell
                                  textAlign="center"
                                  width={2}
                                >
                                  No
                                </Table.HeaderCell>

                                <Table.HeaderCell
                                  textAlign="center"
                                  width={3}
                                >
                                  Pendiente Revisión
                                </Table.HeaderCell>
                              </Table.Row>
                            </Table.Header>

                            <Table.Body>
                              {testG.map(
                                (it, idx) => (
                                  <Table.Row key={it.id}>
                                    <Table.Cell>
                                      {idx + 1}
                                    </Table.Cell>

                                    <Table.Cell
                                      style={{
                                        whiteSpace:
                                          "normal",
                                      }}
                                    >
                                      {it.nombre}
                                    </Table.Cell>

                                    <Table.Cell textAlign="center">
                                      <Input
                                        type="checkbox"
                                        checked={
                                          !!it.valorsi
                                        }
                                        disabled={
                                          savingTest
                                        }
                                        onChange={() =>
                                          handleButtonClickg(
                                            it.id,
                                            "SI"
                                          )
                                        }
                                        style={{
                                          transform:
                                            "scale(1.3)",
                                        }}
                                      />
                                    </Table.Cell>

                                    <Table.Cell textAlign="center">
                                      <Input
                                        type="checkbox"
                                        checked={
                                          !!it.valorno
                                        }
                                        disabled={
                                          savingTest
                                        }
                                        onChange={() =>
                                          handleButtonClickg(
                                            it.id,
                                            "NO"
                                          )
                                        }
                                        style={{
                                          transform:
                                            "scale(1.3)",
                                        }}
                                      />
                                    </Table.Cell>

                                    <Table.Cell textAlign="center">
                                      <Input
                                        type="checkbox"
                                        checked={
                                          !!it.revision
                                        }
                                        disabled={
                                          savingTest
                                        }
                                        onChange={() =>
                                          handleButtonClickg(
                                            it.id,
                                            "REV"
                                          )
                                        }
                                        style={{
                                          transform:
                                            "scale(1.3)",
                                        }}
                                      />
                                    </Table.Cell>
                                  </Table.Row>
                                )
                              )}
                            </Table.Body>
                          </Table>
                        </div>
                      </>
                    )}

                  <Divider />

                  {/* OBSERVACIONES */}

                  <Form>
                    <Form.Field>
                      <label>
                        Observaciones
                      </label>

                      <TextArea
                        placeholder="Ingrese observación o detalles adicionales"
                        value={obs}
                        disabled={savingTest}
                        onChange={(e) =>
                          setObs(e.target.value)
                        }
                        style={{
                          minHeight: 80,
                        }}
                      />
                    </Form.Field>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        color="teal"
                        icon
                        labelPosition="left"
                        disabled={
                          btnValidarTest ||
                          savingTest ||
                          confirmandoTestRef.current
                        }
                        loading={savingTest}
                        onClick={validarTest}
                      >
                        <Icon name="save" />
                        Guardar y Confirmar
                      </Button>
                    </div>
                  </Form>
                </div>
              </Accordion.Content>
            </Accordion>
          </Segment>
        )}

        {/* ========================================================
          DOCUMENTOS POR CONFIRMAR
      ======================================================== */}

        <Segment
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: 12,
            boxShadow: "0 2px 6px rgba(0,0,0,.03)",
            marginTop: 20,
          }}
        >
          <Header as="h3">
            <Icon
              name="clock outline"
              color="orange"
            />

            <Header.Content>
              Documentos por Confirmar

              <Header.Subheader>
                Órdenes pendientes de completar y confirmar en Servicio Técnico
              </Header.Subheader>
            </Header.Content>

            <Label
              circular
              color="orange"
              style={{ marginLeft: 8 }}
            >
              {cabecera.length}
            </Label>
          </Header>

          <div style={{ overflowX: "auto" }}>
            <Table
              celled
              compact="very"
              striped
              selectable
              style={{ fontSize: 12 }}
            >
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>
                    #
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Orden
                  </Table.HeaderCell>

                  <Table.HeaderCell textAlign="center">
                    Origen
                  </Table.HeaderCell>

                  <Table.HeaderCell textAlign="center">
                    Pendiente
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Rut
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Cliente
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Fecha
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Estado
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Ingresado por
                  </Table.HeaderCell>

                  <Table.HeaderCell textAlign="center">
                    Cargar
                  </Table.HeaderCell>

                  <Table.HeaderCell textAlign="center">
                    Anular
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {cabecera.length === 0 ? (
                  <Table.Row>
                    <Table.Cell
                      colSpan="11"
                      textAlign="center"
                    >
                      <div
                        style={{
                          padding: 22,
                          color: "#6b7280",
                        }}
                      >
                        <Icon
                          name="inbox"
                          size="large"
                        />

                        <div
                          style={{
                            marginTop: 8,
                          }}
                        >
                          No existen documentos pendientes.
                        </div>
                      </div>
                    </Table.Cell>
                  </Table.Row>
                ) : (
                  cabecera.map(
                    (it, idx) => {
                      const esIngresoHomeCare =
                        it.origen_ingreso ===
                        "TRASPASO_ST_INTERNO";

                      const faltaEquipo =
                        !it.familia ||
                        !it.tipo ||
                        !it.marca ||
                        !it.modelo ||
                        !it.serie ||
                        !it.servicio;

                      return (
                        <Table.Row key={it.id}>
                          <Table.Cell>
                            {idx + 1}
                          </Table.Cell>

                          <Table.Cell>
                            <strong>
                              {it.folio}
                            </strong>
                          </Table.Cell>

                          {/* ORIGEN */}

                          <Table.Cell textAlign="center">
                            {esIngresoHomeCare ? (
                              <Label
                                basic
                                color="teal"
                                size="mini"
                              >
                                <Icon name="exchange" />
                                HomeCare
                              </Label>
                            ) : (
                              <Label
                                basic
                                size="mini"
                              >
                                Manual
                              </Label>
                            )}
                          </Table.Cell>

                          {/* PENDIENTE */}

                          <Table.Cell textAlign="center">
                            {faltaEquipo ? (
                              <Label
                                basic
                                color="orange"
                                size="mini"
                              >
                                Equipo
                              </Label>
                            ) : (
                              <Label
                                basic
                                color="teal"
                                size="mini"
                              >
                                Test
                              </Label>
                            )}
                          </Table.Cell>

                          <Table.Cell>
                            {it.rut}
                          </Table.Cell>

                          <Table.Cell>
                            {it.entidad}
                          </Table.Cell>

                          <Table.Cell>
                            {formatearFecha(
                              it.date
                            )}
                          </Table.Cell>

                          <Table.Cell>
                            <Label
                              basic
                              color="orange"
                              size="mini"
                            >
                              {it.estado ||
                                "POR CONFIRMAR"}
                            </Label>
                          </Table.Cell>

                          <Table.Cell>
                            {esIngresoHomeCare ? (
                              <span
                                style={{
                                  color: "#6b7280",
                                  fontStyle:
                                    "italic",
                                }}
                              >
                                Generado desde HomeCare
                              </span>
                            ) : (
                              it.useradd || "-"
                            )}
                          </Table.Cell>

                          {/* ================================
                            CARGAR DOCUMENTO
                        ================================ */}

                          <Table.Cell
                            textAlign="center"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={async () => {
                              /*
                               * Limpiamos respuestas de
                               * la orden anterior.
                               */
                              setProtocolo([]);

                              setTestG((prev) =>
                                (prev || []).map(
                                  (x) => ({
                                    ...x,
                                    valorsi: false,
                                    valorno: false,
                                    revision: false,
                                  })
                                )
                              );

                              // CABECERA

                              setFolio(it.folio);
                              setRut(it.rut);

                              fechaDate(
                                it.date
                              );

                              setEntidad(
                                it.entidad
                              );

                              setTelefono(
                                it.telefono
                              );

                              setDireccion(
                                it.direccion
                              );

                              setCorreo(
                                it.correo
                              );

                              setClienteLocked(
                                true
                              );

                              setMostrarInfoEq(
                                true
                              );

                              // FALTA EQUIPO

                              if (faltaEquipo) {
                                setNomFamilia(
                                  it.familia || ""
                                );

                                setNomTipo(
                                  it.tipo || ""
                                );

                                setNomMarca(
                                  it.marca || ""
                                );

                                setNomModelo(
                                  it.modelo || ""
                                );

                                setSerie(
                                  it.serie || ""
                                );

                                setHoraMaquina(
                                  it.horamaquina ??
                                  ""
                                );

                                setServicio(
                                  it.servicio || ""
                                );

                                setObs(
                                  it.observaciones ||
                                  ""
                                );

                                setEquipoLocked(
                                  false
                                );

                                setMostrarTest(
                                  false
                                );

                                setBtnValidarDet(
                                  false
                                );

                                setBtnValidarTest(
                                  true
                                );

                                setActiveCli(
                                  false
                                );

                                setActiveEq(
                                  true
                                );

                                setActiveTest(
                                  false
                                );

                                setStep(2);
                              } else {
                                // EQUIPO COMPLETO -> TEST

                                setNomFamilia(
                                  it.familia || ""
                                );

                                setNomTipo(
                                  it.tipo || ""
                                );

                                setNomMarca(
                                  it.marca || ""
                                );

                                setNomModelo(
                                  it.modelo || ""
                                );

                                setSerie(
                                  it.serie || ""
                                );

                                setHoraMaquina(
                                  it.horamaquina ??
                                  ""
                                );

                                setServicio(
                                  it.servicio || ""
                                );

                                setObs(
                                  it.observaciones ||
                                  ""
                                );

                                setEquipoLocked(
                                  true
                                );

                                if (
                                  it.familia &&
                                  it.tipo
                                ) {
                                  await consultarprot(
                                    it.familia,
                                    it.tipo
                                  );
                                }

                                setMostrarTest(
                                  true
                                );

                                setBtnValidarTest(
                                  false
                                );

                                setActiveCli(
                                  false
                                );

                                setActiveEq(
                                  false
                                );

                                setActiveTest(
                                  true
                                );

                                setStep(3);
                              }

                              setBtnGuardarCab(
                                true
                              );
                            }}
                          >
                            <Icon
                              name="arrow circle up"
                              color="teal"
                              size="large"
                              title={
                                esIngresoHomeCare
                                  ? "Completar orden proveniente de HomeCare"
                                  : "Cargar orden"
                              }
                            />
                          </Table.Cell>

                          {/* ANULAR */}

                          <Table.Cell textAlign="center">
                            <Button
                              basic
                              compact
                              icon
                              size="mini"
                              color="red"
                              onClick={() =>
                                handleAnular(
                                  it.id
                                )
                              }
                              title="Anular orden"
                            >
                              <Icon
                                name="ban"
                                style={{
                                  margin: 0,
                                }}
                              />
                            </Button>
                          </Table.Cell>
                        </Table.Row>
                      );
                    }
                  )
                )}
              </Table.Body>
            </Table>
          </div>
        </Segment>

        {/* ========================================================
          ÓRDENES INGRESADAS
      ======================================================== */}

        <Segment
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: 12,
            boxShadow: "0 2px 6px rgba(0,0,0,.03)",
            marginTop: 16,
          }}
        >
          <Header as="h3">
            <Icon
              name="check circle outline"
              color="teal"
            />

            <Header.Content>
              Órdenes Ingresadas

              <Header.Subheader>
                Equipos recepcionados en Servicio Técnico
              </Header.Subheader>
            </Header.Content>

            <Label
              circular
              color="teal"
              style={{ marginLeft: 8 }}
            >
              {ingresado.length}
            </Label>
          </Header>

          <div style={{ overflowX: "auto" }}>
            <Table
              celled
              compact="very"
              striped
              selectable
            >
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>
                    Folio
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Fecha
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Cliente
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Equipo
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Modelo
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Serie
                  </Table.HeaderCell>

                  <Table.HeaderCell>
                    Servicio
                  </Table.HeaderCell>

                  <Table.HeaderCell textAlign="center">
                    PDF
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {ingresado.length === 0 ? (
                  <Table.Row>
                    <Table.Cell
                      colSpan="8"
                      textAlign="center"
                    >
                      <div
                        style={{
                          padding: 22,
                          color: "#6b7280",
                        }}
                      >
                        <Icon
                          name="inbox"
                          size="large"
                        />

                        <div
                          style={{
                            marginTop: 8,
                          }}
                        >
                          No existen órdenes ingresadas.
                        </div>
                      </div>
                    </Table.Cell>
                  </Table.Row>
                ) : (
                  ingresado.map((it) => (
                    <Table.Row key={it.id}>
                      <Table.Cell
                        style={{
                          fontWeight: 600,
                        }}
                      >
                        {it.folio}
                      </Table.Cell>

                      <Table.Cell>
                        {formatearFecha(
                          it.date
                        )}
                      </Table.Cell>

                      <Table.Cell>
                        {it.entidad}
                      </Table.Cell>

                      <Table.Cell>
                        {it.tipo}
                      </Table.Cell>

                      <Table.Cell>
                        {it.modelo}
                      </Table.Cell>

                      <Table.Cell>
                        {it.serie}
                      </Table.Cell>

                      <Table.Cell>
                        {it.servicio}
                      </Table.Cell>

                      <Table.Cell textAlign="center">
                        <Button
                          basic
                          compact
                          icon
                          size="mini"
                          onClick={() =>
                            pdfver(it.id)
                          }
                          title="Ver PDF"
                          style={{
                            background: "#fff",
                          }}
                        >
                          <Icon
                            name="file pdf outline"
                            color="red"
                            style={{
                              margin: 0,
                              fontSize: "1.25em",
                            }}
                          />
                        </Button>

                        <Button
                          basic
                          compact
                          icon
                          size="mini"
                          onClick={() =>
                            descargarPdf(
                              it.id,
                              it.folio
                            )
                          }
                          title="Descargar PDF"
                          style={{
                            background: "#fff",
                          }}
                        >
                          <Icon
                            name="download"
                            color="teal"
                            style={{ margin: 0 }}
                          />
                        </Button>
                      </Table.Cell>
                    </Table.Row>
                  ))
                )}
              </Table.Body>
            </Table>
          </div>
        </Segment>

        {/* ========================================================
          ALERTAS
      ======================================================== */}

        <Alertas
          tipo={alerta.tipo}
          mensaje={alerta.mensaje}
          estadoAlerta={estadoAlerta}
          cambiarEstadoAlerta={
            cambiarEstadoAlerta
          }
        />

        {/* ========================================================
          MODAL CREAR CLIENTE
      ======================================================== */}

        <Modal
          open={openModalCli}
          onClose={() =>
            !savingCli &&
            setOpenModalCli(false)
          }
          size="small"
          closeOnDimmerClick={!savingCli}
        >
          <Modal.Header>
            <Icon
              name="user plus"
              color="teal"
            />
            Crear Cliente
          </Modal.Header>

          <Modal.Content>
            <Form>
              <Form.Group widths="equal">
                <Form.Field>
                  <label>
                    Rut
                  </label>

                  <Input
                    disabled={savingCli}
                    maxLength="10"
                    placeholder="Rut sin puntos y con guión"
                    value={rut}
                    onChange={(e) =>
                      setRut(
                        e.target.value
                      )
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>
                    Nombre
                  </label>

                  <Input
                    disabled={savingCli}
                    placeholder="Nombre"
                    value={nombre}
                    onChange={(e) =>
                      setNombre(
                        e.target.value
                      )
                    }
                  />
                </Form.Field>
              </Form.Group>

              <Form.Field>
                <label>
                  Dirección
                </label>

                <Input
                  disabled={savingCli}
                  placeholder="Dirección"
                  value={direccion}
                  onChange={(e) =>
                    setDireccion(
                      e.target.value
                    )
                  }
                />
              </Form.Field>

              <Form.Group widths="equal">
                <Form.Field>
                  <label>
                    F. Nacimiento
                  </label>

                  <Input
                    disabled={savingCli}
                    type="datetime-local"
                    value={nacim}
                    onChange={(e) =>
                      setNacim(
                        e.target.value
                      )
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>
                    Región
                  </label>

                  <Dropdown
                    fluid
                    selection
                    disabled={savingCli}
                    value={region}
                    onChange={(
                      e,
                      { value }
                    ) => {
                      setRegion(value);
                      setComuna("");
                    }}
                    options={Regiones.map(
                      (r, i) => ({
                        key: i,
                        text: r.region,
                        value: r.region,
                      })
                    )}
                  />
                </Form.Field>

                <Form.Field>
                  <label>
                    Comuna
                  </label>

                  <Dropdown
                    fluid
                    selection
                    disabled={savingCli}
                    value={comuna}
                    onChange={(
                      e,
                      { value }
                    ) =>
                      setComuna(value)
                    }
                    options={comunasxRegion.map(
                      (c, i) => ({
                        key: i,
                        text: c.name,
                        value: c.name,
                      })
                    )}
                  />
                </Form.Field>
              </Form.Group>

              <Form.Group widths="equal">
                <Form.Field>
                  <label>
                    Teléfono
                  </label>

                  <Input
                    disabled={savingCli}
                    type="number"
                    value={telefono}
                    onChange={(e) =>
                      setTelefono(
                        e.target.value
                      )
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>
                    Email
                  </label>

                  <Input
                    disabled={savingCli}
                    type="email"
                    value={correo}
                    onChange={(e) =>
                      setCorreo(
                        e.target.value
                      )
                    }
                  />
                </Form.Field>

                <Form.Field>
                  <label>
                    Responsable financiero
                  </label>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: 38,
                    }}
                  >
                    <Input
                      type="checkbox"
                      disabled={savingCli}
                      checked={checked}
                      onChange={(e) =>
                        setChecked(
                          e.target.checked
                        )
                      }
                    />
                  </div>
                </Form.Field>
              </Form.Group>

              {checked && (
                <Segment secondary>
                  <Header as="h5">
                    <Icon name="address card outline" />
                    Responsable financiero
                  </Header>

                  <Form.Group widths="equal">
                    <Form.Field>
                      <label>
                        Nombre
                      </label>

                      <Input
                        disabled={savingCli}
                        value={nomRsf}
                        onChange={(e) =>
                          setNomRsf(
                            e.target.value
                          )
                        }
                      />
                    </Form.Field>

                    <Form.Field>
                      <label>
                        Dirección
                      </label>

                      <Input
                        disabled={savingCli}
                        value={dirRsf}
                        onChange={(e) =>
                          setDirRsf(
                            e.target.value
                          )
                        }
                      />
                    </Form.Field>

                    <Form.Field>
                      <label>
                        Teléfono
                      </label>

                      <Input
                        disabled={savingCli}
                        type="number"
                        value={telRsf}
                        onChange={(e) =>
                          setTelRsf(
                            e.target.value
                          )
                        }
                      />
                    </Form.Field>
                  </Form.Group>
                </Segment>
              )}
            </Form>
          </Modal.Content>

          <Modal.Actions>
            <Button
              disabled={savingCli}
              onClick={() =>
                setOpenModalCli(false)
              }
            >
              Cancelar
            </Button>

            <Button
              color="teal"
              loading={savingCli}
              disabled={savingCli}
              onClick={validarCli}
            >
              <Icon name="save" />
              Guardar
            </Button>
          </Modal.Actions>
        </Modal>

        {/* ========================================================
          CONFIRMAR CLIENTE
      ======================================================== */}

        <Modal
          open={confirmCliModal}
          onClose={() =>
            !savingCli &&
            setConfirmCliModal(false)
          }
          size="tiny"
          closeOnDimmerClick={!savingCli}
        >
          <Modal.Header>
            <Icon
              name="question circle outline"
              color="teal"
            />
            Confirmar Cliente
          </Modal.Header>

          <Modal.Content>
            ¿Estás seguro de que deseas guardar los datos de este cliente?
          </Modal.Content>

          <Modal.Actions>
            <Button
              disabled={savingCli}
              onClick={() =>
                setConfirmCliModal(false)
              }
            >
              Cancelar
            </Button>

            <Button
              color="teal"
              loading={savingCli}
              disabled={savingCli}
              onClick={guardarCli}
            >
              <Icon name="save" />
              Guardar
            </Button>
          </Modal.Actions>
        </Modal>

        {/* ========================================================
          CONFIRMAR ORDEN
      ======================================================== */}

        <Modal
          open={confirmTestModal}
          onClose={() => {
            if (
              !savingTest &&
              !confirmandoTestRef.current
            ) {
              setConfirmTestModal(
                false
              );
            }
          }}
          size="tiny"
          closeOnDimmerClick={
            !savingTest &&
            !confirmandoTestRef.current
          }
          closeOnEscape={
            !savingTest &&
            !confirmandoTestRef.current
          }
        >
          <Modal.Header>
            <Icon
              name="clipboard check"
              color="teal"
            />
            Confirmar Orden de Ingreso
          </Modal.Header>

          <Modal.Content>
            <p>
              ¿Guardar el Test de Ingreso y confirmar esta orden?
            </p>

            <Message
              info
              size="small"
            >
              <Icon name="info circle" />

              Una vez confirmada, la orden quedará registrada como{" "}
              <strong>INGRESADA</strong>.
            </Message>
          </Modal.Content>

          <Modal.Actions>
            <Button
              disabled={
                savingTest ||
                confirmandoTestRef.current
              }
              onClick={() =>
                setConfirmTestModal(
                  false
                )
              }
            >
              Cancelar
            </Button>

            <Button
              color="teal"
              loading={savingTest}
              disabled={
                savingTest ||
                confirmandoTestRef.current
              }
              onClick={guardarTest}
            >
              <Icon name="check" />
              Confirmar
            </Button>
          </Modal.Actions>
        </Modal>

        {/* ========================================================
          ANULAR
      ======================================================== */}

        <Modal
          open={confirmAnularModal}
          onClose={() =>
            !savingAny &&
            setConfirmAnularModal(false)
          }
          size="tiny"
          closeOnDimmerClick={!savingAny}
          closeOnEscape={!savingAny}
        >
          <Modal.Header>
            <Icon
              name="warning sign"
              color="red"
            />
            Anular Documento
          </Modal.Header>

          <Modal.Content>
            <Message warning>
              <Message.Header>
                Confirmar anulación
              </Message.Header>

              <p>
                ¿Estás seguro de que deseas anular este documento?
              </p>
            </Message>

            <p>
              La orden quedará en estado{" "}
              <strong>ANULADO</strong>.
            </p>
          </Modal.Content>

          <Modal.Actions>
            <Button
              disabled={savingAny}
              onClick={() =>
                setConfirmAnularModal(
                  false
                )
              }
            >
              Cancelar
            </Button>

            <Button
              color="red"
              disabled={savingAny}
              onClick={anular}
            >
              <Icon name="ban" />
              Anular
            </Button>
          </Modal.Actions>
        </Modal>

        {/* ========================================================
          SERIE CON ORDEN PENDIENTE
      ======================================================== */}

        <Modal
          open={seriePendienteModal}
          onClose={() =>
            setSeriePendienteModal(false)
          }
          size="large"
        >
          <Modal.Header>
            <Icon
              name="warning circle"
              color="orange"
            />
            Existe una Orden de Ingreso Pendiente
          </Modal.Header>

          <Modal.Content scrolling>
            <Message warning>
              <Message.Header>
                El equipo ya tiene una orden pendiente
              </Message.Header>

              <p>
                Se encontró una orden de ingreso no cerrada para el
                número de serie indicado.
              </p>
            </Message>

            <div
              style={{
                overflowX: "auto",
              }}
            >
              <Table
                celled
                compact="very"
                striped
              >
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>
                      #
                    </Table.HeaderCell>

                    <Table.HeaderCell>
                      Orden
                    </Table.HeaderCell>

                    <Table.HeaderCell>
                      Fecha
                    </Table.HeaderCell>

                    <Table.HeaderCell>
                      Equipo
                    </Table.HeaderCell>

                    <Table.HeaderCell>
                      Modelo
                    </Table.HeaderCell>

                    <Table.HeaderCell>
                      Serie
                    </Table.HeaderCell>

                    <Table.HeaderCell>
                      Servicio
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {existeSerie2.map(
                    (it, idx) => (
                      <Table.Row
                        key={
                          it.id ||
                          `${it.folio}-${idx}`
                        }
                      >
                        <Table.Cell>
                          {idx + 1}
                        </Table.Cell>

                        <Table.Cell
                          style={{
                            fontWeight: 600,
                          }}
                        >
                          {it.folio}
                        </Table.Cell>

                        <Table.Cell>
                          {formatearFecha(
                            it.date
                          )}
                        </Table.Cell>

                        <Table.Cell>
                          {it.tipo}
                        </Table.Cell>

                        <Table.Cell>
                          {it.modelo}
                        </Table.Cell>

                        <Table.Cell>
                          {it.serie}
                        </Table.Cell>

                        <Table.Cell>
                          {it.servicio}
                        </Table.Cell>
                      </Table.Row>
                    )
                  )}
                </Table.Body>
              </Table>
            </div>
          </Modal.Content>

          <Modal.Actions>
            <Button
              basic
              onClick={() =>
                setSeriePendienteModal(
                  false
                )
              }
            >
              <Icon name="close" />
              Cerrar
            </Button>
          </Modal.Actions>
        </Modal>

        {/* ========================================================
          VISOR PDF
      ======================================================== */}

        <Modal
          open={openPdf}
          onClose={() =>
            setOpenPdf(false)
          }
          size="large"
          closeOnDimmerClick
        >
          <Modal.Header>
            <Icon
              name="file pdf outline"
              color="red"
            />
            Orden de Ingreso
          </Modal.Header>

          <Modal.Content
            style={{
              padding: 12,
            }}
          >
            <PDFViewer
              width="100%"
              height="550"
              style={{
                border:
                  "1px solid #e5e7eb",
                borderRadius: 6,
              }}
            >
              <SimplePDF
                props={datospdf}
                test={test}
                testGpdf={testGpdf}
                usuario={userAdd}
                empresa={users?.emp_id}
              />
            </PDFViewer>
          </Modal.Content>

          <Modal.Actions>
            <Button
              basic
              onClick={() =>
                setOpenPdf(false)
              }
            >
              <Icon name="close" />
              Cerrar
            </Button>
          </Modal.Actions>
        </Modal>

        {/* ========================================================
          SPINNER GLOBAL
      ======================================================== */}

        <Dimmer
          active={savingAny}
          inverted
        >
          <Loader size="large">
            {savingTest
              ? "Confirmando orden..."
              : "Procesando..."}
          </Loader>
        </Dimmer>

      </Container>
    </Container>
  );


};

export default IngresoEquiposST;